import { AppModule } from "@/shared/types";
import { Auth } from "@/store";

import SettingUser from "./User/index.vue";
import SettingUserDetail from "./User/detail.vue";

import SettingDepartment from "./Department/index.vue";

import SettingShift from "./Shift/index.vue";
import SettingShiftDetail from "./Shift/detail.vue";

const SettingsIwkModule: AppModule = {
  rootLink: "/settings",
  rootIcon: "mdi-cog",
  rootName: "Settings",
  layout: "Sidebar",
  authRequired: false,
  children: [
    {
      path: "user",
      name: "User",
      component: SettingUser,
    },
    {
      path: "user/:uuid",
      name: "User Detail",
      component: SettingUserDetail,
    },
    {
      path: "department",
      name: "Department",
      component: SettingDepartment,
      isHide: Auth.self_role == "Supervisor",
    },
    {
      path: "shift",
      name: "Shift",
      component: SettingShift,
    },
    {
      path: "shift/:uuid",
      name: "Shift Detail",
      component: SettingShiftDetail,
    },
  ],
};

export default SettingsIwkModule;
